import React, { FC } from 'react';
import { EntitiesCardTitle } from '../../../components/entities-card/EntitiesCardTitle';
import { EntitiesTitleLink } from '../../../components/entities-card/EntitiesTitleLink';
import { EnterpriseIcon } from '../../../components/entities-card/icons/EnterpriseIcon';

export const EnterpriseCardTitle: FC<React.HTMLProps<HTMLAnchorElement>> = ({
  children,
  ...props
}) => (
  <EntitiesTitleLink {...props}>
    <EntitiesCardTitle icons={EnterpriseIcon}>{children}</EntitiesCardTitle>
  </EntitiesTitleLink>
);
